/* @flow */
import Avatar from 'components/Avatar.jsx';
import React from 'react';
import User from 'entities/User';
import Subscriber from 'entities/Subscriber';

import './styles/ProfilePicture.scss';

type MinimalRelatedUser = {
  initials: string,
}

const ProfilePicture = ({ user, size }: {
    user: User | Subscriber | MinimalRelatedUser,
    size?: ?'xsmall' | 'small' | 'medium',
  }) => {
  // Because we are migrating off of entities
  // $FlowFixMe
  const initials = user.getInitials ? user.getInitials() : user.initials;

  return (
    <Avatar className="ProfilePicture" text={initials} size={size} />
  );
};

export default ProfilePicture;



// WEBPACK FOOTER //
// ./src/user/components/ProfilePicture.jsx